export default __webpack_public_path__ + "static/media/second.c3c1c80d.mp4";